import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CatalogService } from './catalogs.service';
import { Catalog } from './catalog.model';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-catalogs',
  templateUrl: 'catalogs.component.html',
  styleUrls: ['catalogs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CatalogsComponent implements OnInit, OnDestroy {

 
 public slug: string;
 public pageTitle: string;
 public pageContent: string;
 public catalogs: Catalog[];
 public sub: Subscription = null;
 public cdn = environment.cdn;

 constructor(private router: Router, private route: ActivatedRoute,
             private catalogService: CatalogService, private cdr: ChangeDetectorRef) {}

 ngOnInit() {
  this.slug = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
  // this.getCatalogs(slug);
  this.pageTitle = this.route.snapshot.data.name;
  this.pageContent = this.route.snapshot.data.content;

  this.fetchCatalog();
 }

 fetchCatalog() {
   this.sub = this.catalogService.items({}).pipe(take(1)).subscribe(catalogs => {
       this.catalogs = catalogs.items || null;
       console.log(this.catalogs);
       this.cdr.detectChanges();
   }, error => {
        console.log(error);
   });
 }

 ngOnDestroy() {
   if (this.sub) {
     this.sub.unsubscribe();
   }
 }

}
